import type { User } from '@app/core';
import { create } from 'zustand';

import type { UserRepository } from '../services/repositories.js';

interface UserState {
  user: User | null;
  loading: boolean;

  init: (repo: UserRepository) => Promise<void>;
  completeOnboarding: (repo: UserRepository) => Promise<void>;
}

export const useUserStore = create<UserState>(set => ({
  user: null,
  loading: true,

  init: async (repo: UserRepository) => {
    let user = await repo.get();
    if (!user) {
      user = await repo.create();
    }
    set({ user, loading: false });
  },

  completeOnboarding: async (repo: UserRepository) => {
    const updated = await repo.update({ hasOnboarded: true });
    set({ user: updated });
  },
}));
